$(document).on('click','.header-extra-logos-wraper',function(e){
  e.preventDefault();
  if($(this).hasClass('left-logo')){
      if($('.mega-menu-left-logo').hasClass('active')){
       $('.mega-menu-left-logo').removeClass('active');
       $('.customer-logo-mega-menu-wraper').removeClass('mega-menu-active');
       $(this).removeClass('active');
        $('body').removeClass('active-mega-menu-body');
      }else{
       $('.logo-mega-menu-inner-wraper').removeClass('active'); 
       $('.header-extra-logos-wraper').removeClass('active');
       $('.mega-menu-left-logo').addClass('active');
       $('.customer-logo-mega-menu-wraper').addClass('mega-menu-active');
       $(this).addClass('active');
        $('body').addClass('active-mega-menu-body');
      }
  }else{
      if($('.mega-menu-right-logo').hasClass('active')){
       $('.mega-menu-right-logo').removeClass('active'); 
      $('.customer-logo-mega-menu-wraper').removeClass('mega-menu-active');
       $(this).removeClass('active');
         $('body').removeClass('active-mega-menu-body');
      }else{
        $('.logo-mega-menu-inner-wraper').removeClass('active'); 
        $('.header-extra-logos-wraper').removeClass('active');
        $('.mega-menu-right-logo').addClass('active');
        $('.customer-logo-mega-menu-wraper').addClass('mega-menu-active');
        $(this).addClass('active');
         $('body').addClass('active-mega-menu-body');
      }
  }
});


$('.footer-block--menu').find('.footer-block__heading').click(function(){
 $(this).parents('.footer-block').toggleClass('active');
});
$('.footer-block--text').find('.footer-block__heading').click(function(){
 $(this).parents('.footer-block').toggleClass('active');
});

$(document).on('click', '.labeled-section input[type="checkbox"]', function() {
  $(this).closest('li.list-menu__item').toggleClass('active');
});


$('.js.product-form__input input').change(function(){
    var get_val = $(this).val();
    $(this).parents('fieldset').find('.form__label .option-select-name').text(get_val);
});



$(document).on('click','.custom-menu-drawer-close',function(){
   $('.header__icon.header__icon--menu').trigger('click');
});




